import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';

const AddCustomer = () => {
    const navigate = useNavigate();
    const [customer, setCustomer] = useState({
        custName: "",
        custPhone: "",
        custEmail: "",
        custInsta: "",
        dob: "",
        anniversary: "",
        gender: "Female", // Set default to Female
        custHeight: "",
        address: { 
            street: "", 
            city: "", 
            state: "", 
            pincode: "",
            country: "India" // Set default to India
        },
        measurements: {
            shirt: { length: 0, chest: 0, waist: 0, hip: 0, sleeveLength: 0, mohri: 0 },
            salwar: { salwarLength: 0, mohri: 0 }
        },
        notes: ""
    });

    // Optimized Change Handler
    const handleChange = (e, section, subSection, field) => {
        const { name, value } = e.target;

        if (section === "measurements") {
            // Convert to number for measurements
            const numValue = value === "" ? 0 : parseFloat(value);
            setCustomer(prev => ({
                ...prev,
                measurements: {
                    ...prev.measurements,
                    [subSection]: {
                        ...prev.measurements[subSection],
                        [field]: numValue
                    }
                }
            }));
        } else if (section === "address") {
            setCustomer(prev => ({
                ...prev,
                address: { ...prev.address, [field]: value }
            }));
        } else {
            // Basic fields (Name, Phone, etc)
            setCustomer(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Basic Validation
        if(!customer.custName) {
            alert("Please fill Name");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/add-customer`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(customer)
            });
            
            if (response.ok) {
                alert("Customer Added Successfully!");
                navigate('/customers'); 
            } else {
                const errorData = await response.json();
                alert("Error: " + errorData.message);
            }
        } catch (error) {
            console.error("Error adding customer:", error);
            alert("Server connection failed");
        }
    };

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            <style>
                {`
                    .form-card { border: none; border-radius: 15px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); background: #fff; }
                    .section-title { font-size: 0.9rem; font-weight: 800; color: #0d6efd; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 20px; border-bottom: 2px solid #eef2f7; padding-bottom: 10px; }
                    .form-label { font-weight: 600; color: #495057; font-size: 0.85rem; margin-bottom: 5px; }
                    .form-control, .form-select { border: 1px solid #e0e6ed; padding: 0.6rem 1rem; border-radius: 8px; transition: 0.3s; font-size: 0.9rem; }
                    .form-control:focus { box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1); border-color: #0d6efd; outline: none; }
                    .measurement-input { background-color: #f8f9fa; border-color: #dee2e6; font-weight: bold; color: #0d6efd; }
                    .btn-save { padding: 12px; border-radius: 10px; font-weight: 700; letter-spacing: 0.5px; transition: 0.3s; }
                    .btn-save:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3); }
                `}
            </style>

            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h2 className="fw-bold mb-0">Add New <span className="text-primary">Customer</span></h2>
                        <p className="text-muted small">Fill in the details and body measurements below.</p>
                    </div>
                    <button onClick={() => navigate(-1)} className="btn btn-outline-secondary fw-bold px-4 rounded-pill">Cancel</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                        {/* --- LEFT COLUMN: Basic Info & Address --- */}
                        <div className="col-lg-8">
                            <div className="card form-card p-4 mb-4">
                                <h6 className="section-title">Personal Details</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Full Name *</label>
                                        <input type="text" name="custName" required className="form-control" value={customer.custName} onChange={handleChange} placeholder="Enter full name" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Phone Number</label>
                                        <input type="text" name="custPhone" className="form-control" value={customer.custPhone} onChange={handleChange} placeholder="Mobile number" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Email Address</label>
                                        <input type="email" name="custEmail" className="form-control" value={customer.custEmail} onChange={handleChange} placeholder="email@example.com" />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Instagram ID</label>
                                        <input type="text" name="custInsta" className="form-control" value={customer.custInsta} placeholder="@username" onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Height</label>
                                        <input type="text" name="custHeight" className="form-control" value={customer.custHeight} placeholder="e.g. 5'6''" onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Date of Birth</label>
                                        <input type="date" name="dob" className="form-control" value={customer.dob} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Gender</label>
                                        <select name="gender" className="form-select" value={customer.gender} onChange={handleChange}>
                                            <option value="Female">Female</option>
                                            <option value="Male">Male</option>
                                            <option value="Other">Other</option>
                                            <option value="Unspecified">Unspecified</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="card form-card p-4">
                                <h6 className="section-title">Address & Notes</h6>
                                <div className="row g-3">
                                    <div className="col-md-8">
                                        <label className="form-label">Street Address</label>
                                        <input type="text" className="form-control" value={customer.address.street} onChange={(e) => handleChange(e, "address", null, "street")} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Country</label>
                                        <input type="text" className="form-control" value={customer.address.country} onChange={(e) => handleChange(e, "address", null, "country")} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">City</label>
                                        <input type="text" className="form-control" value={customer.address.city} onChange={(e) => handleChange(e, "address", null, "city")} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">State</label>
                                        <input type="text" className="form-control" value={customer.address.state} onChange={(e) => handleChange(e, "address", null, "state")} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Pincode</label>
                                        <input type="text" className="form-control" value={customer.address.pincode} onChange={(e) => handleChange(e, "address", null, "pincode")} />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Internal Notes</label>
                                        <textarea name="notes" className="form-control" rows="3" value={customer.notes} onChange={handleChange} placeholder="Add any special instructions or preferences..."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* --- RIGHT COLUMN: Measurements --- */}
                        <div className="col-lg-4">
                            <div className="card form-card p-4 mb-4 border-top border-primary border-4">
                                <h6 className="text-primary fw-bold mb-3 d-flex justify-content-between align-items-center">
                                    SHIRT (Inches)
                                    <span className="badge bg-primary-subtle text-primary rounded-pill" style={{fontSize: '0.6rem'}}>REQUIRED</span>
                                </h6>
                                <div className="row g-3">
                                    {['length', 'chest', 'waist', 'hip', 'sleeveLength', 'mohri'].map((field) => (
                                        <div className="col-6" key={field}>
                                            <label className="small fw-bold text-muted text-capitalize">{field.replace(/([A-Z])/g, ' $1')}</label>
                                            <input 
                                                type="number" 
                                                step="0.1" 
                                                className="form-control form-control-sm measurement-input" 
                                                value={customer.measurements.shirt[field]}
                                                onChange={(e) => handleChange(e, "measurements", "shirt", field)} 
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="card form-card p-4 border-top border-success border-4">
                                <h6 className="text-success fw-bold mb-3">SALWAR (Inches)</h6>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <label className="small fw-bold text-muted">Length</label>
                                        <input 
                                            type="number" 
                                            step="0.1" 
                                            className="form-control form-control-sm measurement-input" 
                                            value={customer.measurements.salwar.salwarLength}
                                            onChange={(e) => handleChange(e, "measurements", "salwar", "salwarLength")} 
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label className="small fw-bold text-muted">Mohri</label>
                                        <input 
                                            type="number" 
                                            step="0.1" 
                                            className="form-control form-control-sm measurement-input" 
                                            value={customer.measurements.salwar.mohri}
                                            onChange={(e) => handleChange(e, "measurements", "salwar", "mohri")} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary btn-save w-100 mt-4 shadow-sm">
                                <i className="bi bi-person-check-fill me-2"></i>SAVE CUSTOMER
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCustomer;